import React from 'react';
import {FormattedNumber} from 'react-intl';
import styles from './Answer.css?module';

const voteRatio = (votes, totalVoteCount) => (votes / totalVoteCount) | 0;

const percentage = (votes, totalVoteCount) =>
  voteRatio(votes, totalVoteCount) * 100;

const Answer = ({answer, votes, totalVoteCount}) => (
  <div className={styles.Answer}>
    <div className={styles.label}>
      <div className={styles.text}>{answer}</div>
      <div className={styles.count}>
        <FormattedNumber
          value={voteRatio(votes, totalVoteCount)}
          style="percent"
        />
      </div>
    </div>
    <div className={styles.bar}>
      <div
        className={styles.fill}
        style={{width: `${percentage(votes, totalVoteCount)}%`}}
      />
    </div>
  </div>
);

export default Answer;
